module.exports = __webpack_public_path__ + "static/media/check.b0c320c7.svg";